export function CheckedIcon({ className }: { className?: string }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clip-path="url(#clip0_4226_37214)">
        <circle cx="10.0001" cy="10" r="10" fill="#101828" />
        <path d="M14.1658 6.875L8.43668 12.6042L5.83252 10" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_4226_37214">
          <rect width="20" height="20" rx="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export const displayName = "CheckedIcon";
